import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function fetchHistory (data) {
    return axios.post(`${CRM_API_URL}/print/receipts/history`, data)
      .then(response => response.data)
}

function printXReport (filialId) {
    return axios.post(`${CRM_API_URL}/print/receipts/x-report`, null, {
        params: { filialId },
    }).then(response => response.data)
}

function repeatCommand (id) {
  return axios.post(`${CRM_API_URL}/print/receipts/${id}/repeat`)
    .then(response => {
      return response?.data?.data
    })
}

export default { fetchHistory, printXReport, repeatCommand }
